import { Injectable } from '@angular/core';
import { CanActivateChild, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Claim } from '../_models/claim';

@Injectable()
export class UserClaimGuard implements CanActivateChild {
  constructor(public router: Router) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let routeClaim = null;
    if (route.data.claim) {
      routeClaim = route;
    } else {
      routeClaim = this.verificarRoute(route);
    }
    if (routeClaim && routeClaim.data && routeClaim.data.claim) {
      const claim = routeClaim.data.claim;
      // const userClaims: Array<Claim> = JSON.parse(localStorage.getItem('claims'));
      const userClaims: Array<Claim> = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["claims"];
      if (!userClaims.some(x => x.tipo === claim.tipo && x.acoes.some(y => y.nomeAcao === claim.nomeAcao))) {
        this.router.navigate(['/naoautorizado/pagina-nao-autorizada']);
        return false;
      }
    }
    return true;
  }

  private verificarRoute(route: ActivatedRouteSnapshot): any {
    let claim = null;
    if (route) {
      if (route.firstChild) {
        if (route.firstChild.firstChild) {
          claim = route.firstChild.firstChild;
          return claim;
        } else {
          claim = route.firstChild;
          return claim;
        }
      }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/user-claim-guard.service.ts